import type { Translations } from './types';

export const de: Translations = {
  common: {
    back: 'Zurück',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    retry: 'Erneut versuchen',
    loading: 'Laden...',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    or: 'oder',
    play: 'Abspielen',
    stop: 'Stopp',
    goBack: 'Zurück',
    returnHome: 'Zur Startseite',
    dismiss: 'Schließen',
    unoccupied: 'Unbewohnt',
    resident: 'Bewohner',
  },
  login: {
    appName: 'CARO Care',
    subtitle: 'Melden Sie sich an, um fortzufahren',
    emailLabel: 'E-Mail',
    passwordLabel: 'Passwort',
    signingIn: 'Anmelden...',
    signIn: 'Anmelden',
    qrButton: 'Mit QR-Code aktivieren',
    helpText: 'Hilfe benötigt? Kontaktieren Sie',
    adminSetup: 'Admin-Gerät einrichten',
    activeSessionTitle: 'Ein anderes Gerät ist angemeldet',
    activeSessionMessage: 'Dieses Konto ist auf einem anderen Gerät aktiv. Fortfahren wird alle anderen Geräte abmelden.',
    logoutOthers: 'Fortfahren & Andere Abmelden',
    cancelLogin: 'Abbrechen',
  },
  home: {
    greetingMorning: 'Guten Morgen',
    greetingAfternoon: 'Guten Tag',
    greetingEvening: 'Guten Abend',
    greetingNight: 'Gute Nacht',
    phoneReady: 'Bereit',
    phoneConnecting: '...',
    phoneError: 'Fehler',
    geofenceOutside: 'Außerhalb des Bereichs!',
    geofenceInside: 'Innerhalb des Bereichs',
    geofenceIndicatorOutside: 'Draußen',
    geofenceIndicatorSafe: 'Sicher',
    editLayoutEdit: 'Startbildschirm-Layout bearbeiten',
    editLayoutDone: 'Bearbeitung abschließen',
    openDoor: 'Tür öffnen',
    openDoorSuccess: 'Tür wird geöffnet',
    openDoorError: 'Die Tür konnte nicht geöffnet werden',
    apps: 'Apps',
    widgetButtons: 'Schaltflächen',
  },
  emergency: {
    confirmationTitle: 'Sind Sie sicher, dass Sie Notfallhilfe benötigen?',
    buttonYes: 'JA',
    buttonNo: 'NEIN',
    buttonNoCancel: 'Nein, abbrechen',
    buttonCancel: 'ABBRECHEN',
    countdownMessage: 'Notruf in {seconds} Sekunden...',
    calling: 'Notruf wird gewählt...',
    connected: 'Verbunden',
    resetAlarm: 'Alarm zurücksetzen',
    cancelled: 'Notruf abgebrochen',
    errorApiFailed: 'Notdienste konnten über die App nicht erreicht werden.',
    errorSipUnavailable: 'Telefondienst ist nicht verfügbar. Wählen Sie im Notfall direkt 112.',
    call112: '112 anrufen',
    tryAgain: 'Erneut versuchen',
    callHelp: 'Hilfe rufen',
    fiveSecondsRemaining: '5 Sekunden verbleibend',
    dispatchConnecting: 'Pflegeteam wird alarmiert…',
    dispatchRetry: 'Erneuter Versuch… (Versuch {n})',
    dispatchFailed: 'Keine Verbindung. Wir versuchen es weiter…',
    dispatchFailedVoice: 'Das Pflegeteam ist noch nicht erreichbar. Wir versuchen es weiter. Bitte bleiben Sie ruhig.',
    tryingToCall: 'Notdienst wird angerufen…',
    callingWith: 'Verbunden mit dem Notdienst',
    onRoute: 'Der Notdienst ist unterwegs',
    alarmSent: 'Alarm gesendet, Hilfe wird benachrichtigt…',
    alarmActive: 'Hilfe wird organisiert. Bitte bleiben Sie ruhig.',
  },
  settings: {
    title: 'Einstellungen',
    homeScreen: 'Startbildschirm',
    customizeButtons: 'Schaltflächen anpassen',
    connectionStatus: 'Verbindungsstatus',
    allConnected: 'Alles verbunden',
    display: 'Anzeige & Design',
    language: 'Sprache',
    about: 'Über CARO Care',
    testMode: 'Testmodus',
    logout: 'Abmelden',
    replayOnboarding: 'Willkommenstour wiederholen',
    permissions: 'App-Berechtigungen',
    permissionsValue: 'Mikrofon, Kamera, Standort',
    permissionsTitle: 'App-Berechtigungen',
    permissionsIntro: 'Diese Berechtigungen ermöglichen dem Gerät Anrufe, Video und Benachrichtigungen.',
    permissionsAllowAll: 'Alle Berechtigungen erlauben',
    permissionsRecheck: 'Erneut prüfen',
    permissionsAllGranted: 'Alle Berechtigungen sind erteilt',
    permGranted: 'Erteilt',
    permDenied: 'Verweigert',
    permPrompt: 'Noch nicht erlaubt',
    permDeniedHelp: 'Verweigert. Aktivieren Sie dies in den Systemeinstellungen des Geräts.',
    permMic: 'Mikrofon',
    permMicDesc: 'Für Anrufe erforderlich',
    permCamera: 'Kamera',
    permCameraDesc: 'Für Videoanrufe und Türkamera erforderlich',
    permLocation: 'Standort',
    permLocationDesc: 'Für Sicherheit und Geofencing erforderlich',
    permNotifications: 'Benachrichtigungen',
    permNotificationsDesc: 'Erforderlich, um eingehende Anrufe anzuzeigen',
  },
  buttonLabels: {
    dialer: 'Anrufen',
    contacts: 'Kontakte',
    photos: 'Fotos',
    info: 'Info',
    games: 'Spiele',
    voicemail: 'Voicemail',
    callHistory: 'Anrufliste',
    settings: 'Einstellungen',
    openDoor: 'Tür öffnen',
    agenda: 'Heute',
    weather: 'Wetter',
    news: 'Nachrichten',
    energy: "Energie",
  },
  onboarding: {
    splashTagline: 'Pflege auf Knopfdruck',
    welcomeTitle: 'Willkommen bei CARO Care',
    welcomeSubtitle: 'Ihr persönlicher Pflegebegleiter, entwickelt um Sie verbunden und sicher zu halten.',
    connectedTitle: 'Bleiben Sie verbunden',
    connectedSubtitle: 'Telefonieren Sie, sehen Sie wer an der Tür ist und bleiben Sie mit Familie und Betreuern in Kontakt.',
    homeScreenTitle: 'Ihr Startbildschirm',
    homeScreenSubtitle: 'Wetter, Nachrichten, Ihr Kalender und mehr — alles anpassbar nach Ihren Wünschen.',
    getStartedTitle: 'Bereit loszulegen',
    getStartedSubtitle: 'Lassen Sie uns Ihr Gerät einrichten. Es dauert nur einen Moment.',
    next: 'Weiter',
    skip: 'Überspringen',
    getStartedButton: 'Los geht\'s',
  },
  contacts: {
    title: 'Kontakte',
    emptyTitle: 'Noch keine Kontakte.',
    emptyDescription: 'Ihre Familie und Betreuer können Kontakte für Sie über das Portal hinzufügen.',
    callContact: 'Anrufen',
    loadError: 'Kontakte konnten nicht geladen werden. Bitte erneut versuchen.',
  },
  callHistory: {
    title: 'Anrufverlauf',
    filterAll: 'Alle',
    filterMissed: 'Verpasst',
    filterAnswered: 'Beantwortet',
    filterVoicemail: 'Mailbox',
    loadError: 'Anrufverlauf konnte nicht geladen werden',
    networkError: 'Netzwerkfehler',
    noCalls: 'Noch keine Anrufe',
    today: 'Heute',
    yesterday: 'Gestern',
    statusAnswered: 'Angenommen',
    statusMissed: 'Verpasst',
    statusVoicemail: 'Anrufbeantworter',
    statusRinging: 'Klingelt',
    statusRejected: 'Abgelehnt',
    statusFailed: 'Fehlgeschlagen',
  },
  voicemail: {
    title: 'Mailbox',
    loadingVoicemails: 'Nachrichten laden...',
    loadError: 'Nachrichten konnten nicht geladen werden',
    emptyTitle: 'Keine Nachrichten',
    emptyDescription: 'Wenn jemand Ihnen eine Nachricht hinterlässt, erscheint sie hier.',
    statusKept: 'BEHALTEN',
    statusAutoDelete: '14T Auto-Löschung',
    keep: 'Behalten',
    deleteVoicemail: 'Löschen',
    confirmDelete: 'Diese Nachricht löschen?',
    playError: 'Nachricht konnte nicht abgespielt werden',
    deleteError: 'Nachricht konnte nicht gelöscht werden',
    updateError: 'Nachricht konnte nicht aktualisiert werden',
    daysAgo: 'vor {n} Tagen',
    today: 'Heute',
    yesterday: 'Gestern',
  },
  inCall: {
    connecting: 'Verbinden...',
    dialing: 'Anrufen...',
    onHold: 'Gehalten',
    ended: 'Anruf beendet',
    mute: 'Stumm',
    unmute: 'Stummschaltung aus',
    keypad: 'Tastatur',
    speaker: 'Lautsprecher',
    earpiece: 'Hörer',
    hold: 'Halten',
    resume: 'Fortsetzen',
  },
  incomingCall: {
    emergencyCallback: 'Notruf-Rückruf',
    incoming: 'Eingehender Anruf',
    autoAnswering: 'Automatische Annahme...',
    decline: 'Ablehnen',
    answer: 'Annehmen',
  },
  doorbell: {
    viewing: 'Jemand steht an der Tür',
    calling: 'Verbinden...',
    active: 'Verbunden',
    doorOpened: 'Tür geöffnet',
    opening: 'Tür öffnen...',
    done: 'Anruf beendet',
    noCamera: 'Keine Kamera verfügbar',
    entrance: 'Eingang',
    openDoor: 'Tür öffnen',
    answer: 'Annehmen',
    decline: 'Ablehnen',
    hangup: 'Anruf beenden',
    afwijzen: 'Ablehnen',
    opnemen: 'Annehmen',
    ophangen: 'Auflegen',
    deurOpenen: 'Tür öffnen',
    // See nl.ts for why these four exist and why `doorOpened` is not reused.
    doorReleasing: 'Tür wird geöffnet',
    doorRetried: 'Erneut versucht',
    doorSent: 'Türöffnung gesendet',
    doorFailed: 'Öffnen fehlgeschlagen',
  },
  photos: {
    title: 'Fotos',
    tabAll: 'Alle',
    tabFavorites: 'Favoriten',
    tabHidden: 'Versteckt',
    emptyFavorites: 'Noch keine Lieblingsfotos. Tippen Sie auf das Herz bei einem Foto!',
    emptyHidden: 'Keine versteckten Fotos.',
    emptyAll: 'Noch keine Fotos. Ihre Familie kann Fotos über ihren Link senden.',
    unavailable: 'Foto nicht verfügbar',
  },
  agenda: {
    title: 'Kalender',
    today: 'Heute',
    allDay: 'Ganztägig',
    spots: 'Plätze',
    open: 'Öffnen',
    addedBy: 'Hinzugefügt von',
    emptyMessage: 'Keine Termine für diese Woche geplant',
    cancelSignup: 'Abmelden',
    join: 'Teilnehmen',
    previousWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    tomorrow: 'Morgen',
    addEntry: '+ Hinzufügen',
    privateMarker: 'Privat',
    privateExplain: 'Nur Sie sehen das',
    newEntryTitle: 'Etwas in Ihren Kalender eintragen',
    entryTitleLabel: 'Worum geht es?',
    entryWhenLabel: 'Wann?',
    entryDurationLabel: 'Wie lange?',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    signupOpen: 'Anmelden',
    signupClosed: 'Die Anmeldung ist geschlossen',
    signupFull: 'Ausgebucht',
    signupAlready: 'Sie sind angemeldet',
    moreInfo: 'Mehr Infos',
    withdrawClosed: 'Diese Aktivität läuft bereits oder ist vorbei. Eine Abmeldung ist nicht mehr möglich — wenden Sie sich an das Personal.',
    withdrawFailed: 'Abmelden fehlgeschlagen',
    noBillingAccount: 'Anmeldung über die Betreuung',
    waitlisted: 'Sie stehen auf der Warteliste',
    whoIsComing: 'Wer kommt mit?',
    attendeeYou: 'Sie selbst',
    confirmTitle: 'Kurz bestätigen',
    confirmTotal: 'Gesamt',
    confirmOnApartmentBill: 'Das kommt auf die Rechnung Ihrer Wohnung.',
    confirmYes: 'Ja, bitte anmelden',
    confirmNo: 'Nein, doch nicht',
    signupFailed: 'Die Anmeldung hat nicht geklappt. Versuchen Sie es erneut oder fragen Sie die Betreuung.',
    priceChanged: 'Der Preis hat sich inzwischen geändert. Bitte schauen Sie noch einmal.',
  },
  dialer: {
    title: 'Wahl',
    connectingMessage: 'Verbindung zum Telefondienst...',
    notConnectedMessage: 'Telefondienst nicht verbunden',
  },
  info: {
    title: 'Info',
    myProfile: 'Mein Profil',
    name: 'Name',
    email: 'E-Mail',
    location: 'Standort',
    myBuilding: 'Mein Gebäude',
    building: 'Gebäude',
    needHelp: 'Hilfe benötigt?',
    helpText: 'Drücken Sie den roten Notfallknopf auf dem Startbildschirm oder bitten Sie einen Betreuer um Hilfe.',
    about: 'Über diese App',
    appVersion: 'Version',
    linkedTo: 'Dieses Tablet ist verknüpft mit',
    resident: 'Bewohner',
    apartment: 'Wohnung',
    site: 'Standort / Gebäude',
    extension: 'Durchwahl',
    notLinked: 'nicht verknüpft',
  },
  connectivity: {
    title: 'Verbindungsstatus',
    allConnected: 'Alle Systeme verbunden',
    limited: 'Eingeschränkte Verbindung',
    offline: 'Offline',
    checking: 'Prüfen...',
    emergencyAvailable: 'Notrufe verfügbar',
    degradedMessage: 'Einige Dienste sind möglicherweise nicht verfügbar',
    offlineMessage: 'Keine Verbindung erkannt',
    networkLabel: 'WLAN / Netzwerk',
    networkDescription: 'Lokale Netzwerkverbindung',
    internetLabel: 'Internet',
    internetDescription: 'Internetzugang',
    apiLabel: 'CARO Server',
    apiDescription: 'CARO Cloud-Dienste',
    sipLabel: 'Telefondienst',
    sipDescription: 'Sprachanruf-Fähigkeit',
    mqttLabel: 'Überwachung',
    mqttDescription: 'Gerätetelemetrie & Fernsteuerung',
    statusOk: 'OK',
    statusDown: 'Nicht verfügbar',
    checkAgain: 'Erneut prüfen',
    noNetwork: 'Keine Netzwerkverbindung',
    offlineEmergencyText: 'Wählen Sie im Notfall direkt 112 mit Ihrem Telefon.',
  },
  homeScreenSettings: {
    title: 'Startbildschirm',
    subtitle: 'Wählen Sie, welche Schaltflächen auf Ihrer Startseite erscheinen',
    buttonCount: '{count} von {total} Schaltflächen sichtbar',
    resetToDefault: 'Zurücksetzen',
  },
  games: {
    title: 'Spiele',
    subtitle: 'Halten Sie Ihren Geist fit und haben Sie Spaß',
    memory: { name: 'Memory', desc: 'Finden Sie die Paare' },
    sudoku: { name: 'Sudoku', desc: 'Zahlenrätsel' },
    wordSearch: { name: 'Wortsuche', desc: 'Finden Sie versteckte Wörter' },
    trivia: { name: 'Quizspiel', desc: 'Testen Sie Ihr Wissen' },
    game2048: { name: '2048', desc: 'Schieben & zusammenfügen' },
    solitaire: { name: 'Solitär', desc: 'Klassisches Kartenspiel' },
    ticTacToe: { name: 'Tic-Tac-Toe', desc: 'X und O Strategie' },
    hangman: { name: 'Galgenmännchen', desc: 'Erraten Sie das Wort' },
    colorMatch: { name: 'Farbmuster', desc: 'Merken Sie sich das Muster' },
    chess: { name: 'Schach', desc: 'Klassisches Strategiespiel' },
    checkers: { name: 'Dame', desc: 'Springen und schlagen' },
    findDifferences: { name: 'Unterschiede finden', desc: 'Finden Sie die Änderungen' },
    slidingPuzzle: { name: 'Schiebepuzzle', desc: 'Schieben Sie die Kacheln' },
  },
  gameCommon: {
    playAgain: 'Nochmal spielen',
    changeDifficulty: 'Schwierigkeit ändern',
    backToGames: 'Zurück zu Spielen',
    newGame: 'Neues Spiel',
    tryAgain: 'Erneut versuchen',
    keepPlaying: 'Weiterspielen',
    congratulations: 'Herzlichen Glückwunsch!',
    score: 'Punkte',
    best: 'Beste',
    time: 'Zeit',
    moves: 'Züge',
    easy: 'Leicht',
    medium: 'Mittel',
    hard: 'Schwer',
    gameOver: 'Spiel vorbei!',
  },
  memoryGame: {
    chooseDifficulty: 'Wählen Sie den Schwierigkeitsgrad',
    matchPairsSubtitle: 'Finden Sie alle Paare, um zu gewinnen!',
    encourageAmazing: 'Fantastisches Gedächtnis! Sie sind ein Naturtalent!',
    encourageGreat: 'Toll gemacht! Sehr gut!',
    encourageNice: 'Schöne Arbeit! Weiter üben!',
    encourageWellDone: 'Gut gemacht! Jedes Spiel macht Sie schärfer!',
  },
  sudokuGame: {
    chooseDifficulty: 'Wählen Sie Ihren Schwierigkeitsgrad:',
    blanks: 'leere Felder',
    hintsUsed: 'Hinweise verwendet',
    hintsDisplay: 'Hinweise',
    solvedPuzzle: 'Sie haben das Rätsel gelöst!',
  },
  game2048: {
    youReached: 'Sie haben 2048 erreicht!',
  },
  triviaGame: {
    chooseCategory: 'Wählen Sie eine Kategorie, um Ihr Quiz zu starten!',
    questions: 'Fragen',
    questionProgress: 'Frage {current} von {total}',
    correct: 'Richtig! Gut gemacht!',
    incorrect: 'Nicht ganz. Die richtige Antwort ist oben hervorgehoben.',
    nextQuestion: 'Nächste Frage',
    seeResults: 'Ergebnisse ansehen',
    chooseCategoryBtn: 'Kategorie wählen',
    resultPerfect: 'Perfekte Punktzahl! Sie sind ein Quiz-Meister!',
    resultExcellent: 'Ausgezeichnete Arbeit! Sie kennen sich wirklich aus!',
    resultGreat: 'Toll gemacht! Sie haben ein wundervolles Gedächtnis!',
    resultGood: 'Guter Einsatz! Spielen Sie weiter, um mehr zu lernen!',
    resultNiceTry: 'Guter Versuch! Jedes Spiel macht Sie klüger!',
    history: 'Geschichte',
    nature: 'Natur',
    music: 'Musik',
    geography: 'Geographie',
    science: 'Wissenschaft',
  },
  wordSearchGame: {
    chooseTheme: 'Wählen Sie ein Thema zum Starten',
    words: 'Wörter',
    theme: 'Thema',
    wordsFound: 'gefunden',
    hintSelectStart: 'Tippen Sie auf den ersten Buchstaben eines Wortes',
    hintSelectEnd: 'Tippen Sie auf das Ende des Wortes',
    allWordsFound: 'Alle Wörter gefunden!',
    completionMessage: 'Sie haben das Rätsel gelöst!',
    newPuzzle: 'Neues Rätsel',
    changeTheme: 'Thema ändern',
    animals: 'Tiere',
    food: 'Essen',
    natureTheme: 'Natur',
    home: 'Zuhause',
    colors: 'Farben',
  },
  hangmanGame: {
    guessTheWord: 'Erraten Sie das Wort!',
    category: 'Kategorie',
    youWon: 'Sie haben es erraten!',
    youLost: 'Zu viele falsche Buchstaben!',
    theWordWas: 'Das Wort war',
    wrongGuesses: 'Falsche Buchstaben',
    animals: 'Tiere',
    food: 'Essen',
    countries: 'Länder',
    household: 'Haushalt',
  },
  colorMatchGame: {
    watchPattern: 'Muster beobachten...',
    yourTurn: 'Sie sind dran!',
    round: 'Runde',
    bestStreak: 'Beste Serie',
    wrongPattern: 'Falsch! Spiel vorbei.',
    newRecord: 'Neuer Rekord!',
  },
  solitaireGame: {
    undo: 'Rückgängig',
    draw: 'Ziehen',
    autoComplete: 'Automatisch vervollständigen',
    youWon: 'Sie haben gewonnen!',
    movesUsed: 'Züge verwendet',
  },
  ticTacToeGame: {
    yourTurn: 'Ihr Zug (X)',
    aiTurn: 'Computer denkt nach...',
    youWin: 'Sie gewinnen!',
    aiWins: 'Computer gewinnt!',
    draw: 'Unentschieden!',
    chooseDifficulty: 'Wählen Sie den Schwierigkeitsgrad:',
    wins: 'Siege',
    losses: 'Niederlagen',
    draws: 'Unentschieden',
  },
  browser: {
    title: 'Browser',
    noUrl: 'Keine URL angegeben',
    emergency: 'Notfall',
  },
  display: {
    title: 'Anzeige & Design',
    brightness: 'Helligkeit',
    screen: 'Bildschirm',
    sleepMode: 'Ruhemodus',
    sleepModeDesc: 'Bildschirm ausschalten. Tippen Sie irgendwo zum Aufwachen.',
    tapToWake: 'Tippen zum Aufwachen',
    fontSize: 'Schriftgröße',
    fontNormal: 'Normal',
    fontLarge: 'Groß',
    fontXLarge: 'Sehr groß',
    fontHuge: 'Riesig',
    fontGiant: 'Gigantisch',
    colorTheme: 'Farbthema',
    light: 'Hell',
    dark: 'Dunkel',
    highContrast: 'Hoher Kontrast',
    screensaverMode: 'Bildschirmschoner',
    screensaverPhotos: 'Fotos',
    screensaverClockOnly: 'Nur Uhr',
    standbyBackground: 'Hintergrund Bildschirmschoner',
    clockStyle: 'Uhrstil',
    clockDigital: 'Digital',
    clockAnalog: 'Analog',
    clockSize: 'Uhrgröße',
    clockSmall: 'Klein',
    clockMedium: 'Mittel',
    clockLarge: 'Groß',
    clockXLarge: 'Sehr groß',
    clockHuge: 'Riesig',
    clockBold: 'Uhrziffern',
    clockBoldOff: 'Dünn',
    clockBoldOn: 'Fett',
    clockShowYear: 'Jahr im Datum',
    clockShowYearOff: 'Ausblenden',
    clockShowYearOn: 'Anzeigen',
    weatherLocation: 'Wetterstandort',
    weatherLocationPlaceholder: 'z.B. Deinze, Belgien',
    weatherLocationHint: 'Leer lassen für Gebäudestandort',
    detectLocation: 'Erkennen',
    reduceMotion: 'Bewegung reduzieren',
    reduceMotionHint: 'Animationen und Übergänge in der App begrenzen.',
    reduceMotionAuto: 'Auto (Gerät folgen)',
    reduceMotionOn: 'Ein',
    reduceMotionOff: 'Aus',
  },
  today: {
    title: 'Heute',
    noEvents: 'Keine Termine heute',
    now: 'JETZT',
    allDay: 'Ganztägig',
    inTime: 'in {time}',
    nextEvent: 'Als Nächstes: {title} um {time}',
  },
  energy: {
    title: "Energie",
    loading: "Verbrauch wird geladen...",
    unavailable: "Ihr Verbrauch ist hier noch nicht verfügbar.",
    noMeter: "Mit Ihrer Wohnung ist noch kein Zähler verknüpft.",
    thisMonth: "Dieser Monat",
    lastYearSameMonth: "Gleicher Monat letztes Jahr",
    sinceJanuary: "Seit Januar",
    middleApartmentSoFar: "Die mittlere Wohnung des Gebäudes: bisher {value}.",
    last12: "Die letzten 12 Monate",
    showList: "Als Liste",
    showChart: "Als Grafik",
    running: "laufend",
    thisYear: "Ihr Verbrauch",
    lastYear: "letztes Jahr",
    comparison: "Im {month} haben Sie {you} verbraucht. Die mittlere Wohnung des Gebäudes verbrauchte {middle}.",
    comparisonNote: "Ihr Verbrauch hängt von Größe und Lage Ihrer Wohnung und davon ab, wie oft Sie zu Hause sind. Ein Unterschied ist also nicht immer vermeidbar.",
    lastSettlement: "Letzter Abrechnungsstand: {value} am {date}.",
    footer: "Diese Angaben helfen Ihnen, Ihren Verbrauch zu verfolgen. Es ist keine Rechnung.",
  },
  weather: {
    title: 'Wetter',
    feelsLike: 'Gefühlt',
    humidity: 'Luftfeuchtigkeit',
    wind: 'Wind',
    sunrise: 'Sonnenaufgang',
    sunset: 'Sonnenuntergang',
    forecast: 'Vorhersage',
    loading: 'Wetter laden...',
    unavailable: 'Wetter nicht verfügbar',
    high: 'H',
    low: 'T',
  },
  news: {
    title: 'Nachrichten',
    loading: 'Nachrichten laden...',
    noArticles: 'Keine Artikel verfügbar',
    readMore: 'Weiterlesen',
    sources: 'Quellen',
    minutesAgo: 'vor {n}Min',
    hoursAgo: 'vor {n}Std',
  },
  permissions: {
    title: 'Berechtigungen erforderlich',
    description: 'CARO Care benötigt die folgenden Berechtigungen, um ordnungsgemäß zu funktionieren. Bitte erlauben Sie den Zugriff, um fortzufahren.',
    microphone: 'Mikrofon',
    microphoneDesc: 'Erforderlich für Telefongespräche und Notfallalarm',
    camera: 'Kamera',
    cameraDesc: 'Erforderlich für Türklingel-Kamera und QR-Code-Scan',
    location: 'Standort',
    locationDesc: 'Erforderlich für Sicherheitsüberwachung in Ihrem Gebäude',
    allowAll: 'Alle Berechtigungen erlauben',
    deniedHelp: 'Einige Berechtigungen wurden verweigert. Öffnen Sie Einstellungen > Apps > CARO Care > Berechtigungen, um sie zu aktivieren.',
    notifications: 'Benachrichtigungen',
    notificationsDesc: 'Erforderlich für eingehende Anrufe und Notfallbenachrichtigungen',
    openSettings: 'Einstellungen öffnen',
  },
  battery: {
    lowTitle: 'Niedriger Akkustand',
    lowMessage: 'Der Akku ist fast leer. Bitte schließen Sie das Ladegerät an.',
    highTitle: 'Akku geladen',
    highMessage: 'Der Akku ist ausreichend geladen. Sie können das Ladegerät trennen, um den Akku zu schonen.',
    lowSpoken: 'Achtung. Ihr Akku ist fast leer. Bitte schließen Sie das Ladegerät an.',
  },
  domotics: {
    title: 'Haussteuerung',
    back: '← Zurück',
    backPlain: 'Zurück',
    loading: 'Wird geladen',
    notReady: 'Die Haussteuerung ist auf diesem Gerät noch nicht bereit.',
    notEnabled: 'Die Haussteuerung ist für diese Wohnung nicht eingeschaltet.',
    editTitle: 'Anpassen',
    editButton: '✏️ Anpassen',
    doneButton: '✓ Fertig',
    done: 'Fertig',
    editModeHint: 'Tippen Sie auf eine Kachel, um sie umzubenennen, zu verschieben, auf den Startbildschirm zu legen oder auszublenden. Es wird nichts geschaltet.',
    allOff: 'Alles ist aus',
    oneOutputOn: ' Ausgang ist an',
    manyOutputsOn: ' Ausgänge sind an',
    rooms: 'Räume',
    all: 'Alle',
    noRoomsYet: 'Noch keine Räume',
    roomsHint: '{label} — Sie legen einen an, indem Sie eine Kachel öffnen und „In Raum verschieben" wählen.',
    nothingConfigured: 'Für diese Wohnung ist noch nichts eingerichtet.',
    newScene: 'Neue Stimmung',
    newSceneAria: 'Neue Stimmung anlegen',
    scenesFolder: 'Stimmungen',
    errorRenameImmutable: 'Diese Stimmung wurde von CARO eingerichtet und kann nicht umbenannt werden.',
    errorSaveFailed: 'Speichern hat nicht geklappt.',
    errorSceneLimit: 'Es gibt schon zwölf Stimmungen. Löschen Sie zuerst eine.',
    errorSceneEmpty: 'Wählen Sie mindestens eine Lampe für diese Stimmung.',
    errorSceneNameRequired: 'Geben Sie der Stimmung einen Namen.',
    errorSceneImmutable: 'Diese Stimmung wurde von CARO eingerichtet.',
    errorDeleteFailed: 'Löschen hat nicht geklappt.',
    errorSceneOpenFailed: 'Diese Stimmung konnte nicht geöffnet werden.',
    errorHomeFailed: 'Der Startbildschirm konnte nicht aktualisiert werden.',
    errorPrefFailed: 'Die Änderung konnte nicht gespeichert werden.',
    errorRoomFailed: 'Der Raum konnte nicht gespeichert werden.',
    notSent: 'Nicht gesendet',
    retry: 'Erneut',
    sensorActive: 'aktiv',
    sensorIdle: 'Ruhe',
    sending: 'gesendet…',
    editAria: '{name}, anpassen',
    readOnlyAria: '{name}, nur lesen, {extra}',
    longPressHint: '. Lange drücken zum Dimmen.',
    hiddenBadge: 'ausgeblendet',
    editBadge: 'anpassen',
    strengthOf: 'Helligkeit von {name}',
    close: 'Schließen',
    weaker: 'Dunkler',
    stronger: 'Heller',
    strength: 'Helligkeit',
    off: 'Aus',
    full: 'Voll',
    editScene: 'Stimmung anpassen',
    editSceneSub: 'Name und welche Lampen mitmachen',
    rename: 'Umbenennen',
    renameSub: 'Jetzt: {name}',
    moveToRoom: 'In Raum verschieben',
    inRoom: 'Ist jetzt in {room}',
    inNoRoom: 'Ist in keinem Raum. So legen Sie einen neuen Raum an.',
    homeRemove: 'Vom Startbildschirm entfernen',
    homeAdd: 'Auf den Startbildschirm legen',
    homeRemoveSub: 'Ist jetzt auf dem Startbildschirm, neben dem Notrufknopf',
    homeAddSub: 'Erscheint auf dem Startbildschirm neben dem Notrufknopf, damit Sie nicht erst hierher müssen',
    show: 'Wieder anzeigen',
    hide: 'Ausblenden',
    showSub: 'Kommt zurück in die normale Liste',
    hideSub: 'Bleibt in diesem Anpassmodus sichtbar, damit Sie es zurückholen können',
    templateNote: 'Diese Stimmung wurde für das ganze Gebäude eingerichtet. Sie können sie benutzen, aber nicht ändern.',
    whereTitle: 'Wohin gehört {name}?',
    cancel: 'Abbrechen',
    currentRoom: 'Ist jetzt hier',
    removeFromRoom: 'Aus {room} entfernen',
    removeFromRoomSub: 'Erscheint dann nur noch unter „Alle"',
    newRoom: 'Neuer Raum',
    newRoomPlaceholder: 'Zum Beispiel: Schlafzimmer',
    create: 'Anlegen',
    renameQuestion: 'Wie möchten Sie das nennen?',
    save: 'Speichern',
    saving: 'Speichern…',
    newSceneTitle: 'Neue Stimmung',
    confirmDelete: 'Sind Sie sicher?',
    delete: 'Löschen',
    sceneName: 'Name der Stimmung',
    sceneNamePlaceholder: 'Zum Beispiel: Abend',
    sceneRoomQuestion: 'In welchen Raum gehört diese Stimmung?',
    sceneRoomPlaceholder: 'Leer lassen für keinen Raum',
    sceneWhichLamps: 'Welche Lampen machen mit?',
    sceneCaptureNow: 'Übernehmen, was jetzt an ist',
    sceneNoLamps: 'Es gibt noch keine Lampen für eine Stimmung.',
    sceneStrengthOf: 'Helligkeit von {name} in dieser Stimmung',
    on: 'an',
    offLower: 'aus',
  },
  notifications: {
    title: 'Nachrichten',
    backToHome: 'Zurück zum Startbildschirm',
    empty: 'Im Moment gibt es keine Nachrichten.',
    priorityUrgent: 'Dringend',
    priorityHigh: 'Wichtig',
    priorityNormal: 'Nachricht',
    priorityLow: 'Zur Information',
    read: '• gelesen',
    unread: '• neu',
    today: 'Heute {time}',
    close: 'Schließen',
    stayUntilClosed: 'Diese Nachricht bleibt stehen, bis Sie sie schließen.',
    closesIn: 'Schließt in {n} Sekunden',
    pausedDuringCall: 'Während des Gesprächs pausiert',
    busy: 'Bitte warten…',
    errorRouteNotAllowed: 'Dieses Ziel ist nicht erlaubt.',
    errorNotDelivered: 'Der Befehl ist nicht angekommen. Bitte versuchen Sie es erneut.',
    errorUnavailable: 'Diese Taste ist vorübergehend nicht verfügbar.',
    errorOffline: 'Keine Verbindung. Bitte versuchen Sie es erneut.',
    errorExpired: 'Diese Nachricht ist nicht mehr gültig.',
    errorGeneric: 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.',
    backgroundOf: 'Hintergrund {n} von {total}',
    cameraUnavailable: 'Kamerabild nicht verfügbar',
    imageUnavailable: 'Bild nicht verfügbar',
    previousImage: 'Vorheriges Bild',
    nextImage: 'Nächstes Bild',
    goToImage: 'Zu Bild {n}',
    system: {
      system_test: { title: 'Testnachricht', body: 'Dies ist ein Test für {name}.' },
    },
  },
  doorbellCamera: {
    door: 'Türsprechanlage',
    camera: 'Kamera {name}',
    countdown: 'Bild endet in {time}',
  },
  commandPopup: {
    message: 'Nachricht',
    speaking: 'Wird vorgelesen',
    playingSound: 'Ton',
    sound: 'Ton: {sound}',
    times: ' ({n}x)',
  },
  gamesA11y: {
    goBack: 'Zurück',
    backToGames: 'Zurück zu den Spielen',
    moveUp: 'Nach oben',
    moveLeft: 'Nach links',
    moveDown: 'Nach unten',
    moveRight: 'Nach rechts',
    flipCard: 'Karte umdrehen',
    faceDownCard: 'Verdeckte Karte',
    emptySlot: 'Leerer Platz',
    cardOf: '{rank} {suit}',
    cell: 'Feld {n}',
    empty: 'leer',
    rowCol: 'Reihe {row}, Spalte {col}',
    valueOf: 'Wert {value}',
    given: 'vorgegeben',
    redPiece: 'roter Stein',
    blackPiece: 'schwarzer Stein',
    white: 'Weiß',
    black: 'Schwarz',
    hint: 'Tipp',
    tile: 'Kachel {n}',
    tapToSlide: 'tippen zum Schieben',
    hangmanFigure: 'Galgenmännchen: {wrong} von {max} falschen Buchstaben',
  },
};
